module.exports = __webpack_public_path__ + "assets/img/title-0f96ba1c.png";